module.exports = __webpack_public_path__ + "static/img/order_card_bg.b917070a.png";